<tt-page class="col-xs-12 col-md-4 sp-0" *ngIf="!!setting">
    <tt-card>
        <tt-input *ngIf="setting.show_other_labours === '0'" ttLabel="labour_name" [ttModel]="setting.labour_name" ttReadonly></tt-input>
        <tt-select *ngIf="setting.show_other_labours === '1'" ttLabel="labour_name" [(ttModel)]="setting.labour_no" (ttModelChange)="onChanged($event, 'labour_no')" [ttData]="selectListLabours" ttDataId="item_id" ttDataName="item_name"></tt-select>
    </tt-card>

    <tt-list [ttData]="itemsListPlans"></tt-list>

    <tt-card *ngIf="setting.show_setting === '1'">
        <tt-button-settings></tt-button-settings>
    </tt-card>
</tt-page>
